import * as React from 'react';
import { Tag } from '../types';
export const GridRow = ({ nowrap, children, tag: Element = Tag.DIV, }) => {
    const className = `grid-row${nowrap ? ' grid-row__no-wrap' : ''}`;
    return React.createElement(Element, { className: className }, children);
};
//# sourceMappingURL=component.js.map